
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1(2|44|75)|0|588|735|784)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
